import routes from 'routes/courses'

const Courses = () =>
  routes

export default Courses
